import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'

import StatusText from './questbanner/StatusText'
import ReviewStatusIndicators from './questbanner/ReviewStatusIndicators'
import ModalComponent from '../mini/ModalComponent'

import {
  stopReview,
  deleteCompiledQuestReview,
  revertQuestToDraft,
  createCompiledQuest
} from '../../actions/review'
import {
  getReviewStatus,
  getFriendlyStatus,
  isActiveWithThisReviewer,
  questIsInQualityReview,
  questIsInRejectedState,
  allRequiredFieldsComplete,
  canSubmitForReview,
  questInDraftAfterRejection,
  canSubmitButNotReady
} from '../../utils/review'
import {
  isInternalReviewer,
  isOeReviewer,
  isQuestCopyEditorOrQuestAuthorOrQuestManager
} from '../../utils/user'
import { cancelReview, editQuest } from '../../utils/messages'
import {
  headingMessages,
  bodyMessages,
  buttonMessages
} from '../../utils/messages/modal'
import { questHasAssignment } from '../../utils/assignment'

class ReviewBanner extends Component {
  constructor(props) {
    super(props)
    this.onStopReviewClickBound = this.onStopReviewClick.bind(this)
    this.onActualStopReviewClickBound = this.onActualStopReviewClick.bind(this)
    this.onCancelReviewClickBound = this.onCancelReviewClick.bind(this)
    this.onActualCancelClickBound = this.onActualCancelClick.bind(this)
    this.onEditQuestClickBound = this.onEditQuestClick.bind(this)
    this.onEditPublishedQuestClickBound =
      this.onEditPublishedQuestClick.bind(this)
    this.onActualEditPublishedQuestClickBound =
      this.onActualEditPublishedQuestClick.bind(this)
    this.hideModalBound = this.hideModal.bind(this)
  }

  componentDidMount() {
    this.stopReviewModal = this.refs.stopReviewModal.refs.modal
    this.cancelReviewModal = this.refs.cancelReviewModal.refs.modal
    this.editPublishedQuestModal = this.refs.editPublishedQuestModal.refs.modal
  }

  render() {
    const { quest, user, activeReview, organization, approvals, activities } =
      this.props

    const { intl } = this.context
    const reviewStatus = getReviewStatus(quest)
    const friendlyStatus = getFriendlyStatus(reviewStatus)

    const modalMessages = {
      header: {
        reviewInProgress: intl.formatMessage(headingMessages.reviewInProgress),
        thisQuestIsPublished: intl.formatMessage(
          headingMessages.thisQuestIsPublished
        ),
        cancelReview: intl.formatMessage(headingMessages.cancelReview)
      },
      body: {
        ifYouStop1: intl.formatMessage(bodyMessages.ifYouStop1),
        ifYouStop2: intl.formatMessage(bodyMessages.ifYouStop2),
        ifYouStop3: intl.formatMessage(bodyMessages.ifYouStop3),
        toEditThisQuest: intl.formatMessage(bodyMessages.toEditThisQuest),
        ifYouCancel: intl.formatMessage(bodyMessages.ifYouCancel)
      },
      button: {
        yes: intl.formatMessage(buttonMessages.yes),
        ok: intl.formatMessage(buttonMessages.ok),
        cancel: intl.formatMessage(buttonMessages.cancel),
        no: intl.formatMessage(buttonMessages.no)
      }
    }

    return (
      <div className={`review-banner ${reviewStatus}`}>
        <div
          className={`left ${this.showBlackBanner() ? 'right-is-active' : ''}`}
        >
          <div className="status">{friendlyStatus}</div>
          <div className="pointer-container">
            <div className="pointer"></div>
          </div>
        </div>
        <div className={`right ${this.showBlackBanner() ? 'active' : ''}`}>
          {this.showReviewStatusIndicators() && (
            <ReviewStatusIndicators
              {...this.props}
              reviewStatus={reviewStatus}
            />
          )}
          <StatusText
            quest={quest}
            approvals={approvals}
            currentCompiledQuest={
              quest.current_compiled_quest ? quest.current_compiled_quest : ''
            }
            canSubmitForReview={canSubmitForReview(
              user,
              quest,
              organization,
              activities
            )}
            isQuestCopyEditorOrQuestAuthorOrQuestManager={isQuestCopyEditorOrQuestAuthorOrQuestManager(
              user,
              quest,
              organization
            )}
            questIsInRejectedState={questIsInRejectedState(quest)}
            questIsInQualityReview={questIsInQualityReview(quest)}
            questHasAssignment={questHasAssignment(quest)}
            canSubmitButNotReady={canSubmitButNotReady(
              user,
              quest,
              organization,
              activities
            )}
            questInDraftAfterRejection={questInDraftAfterRejection(quest)}
          />
          {isQuestCopyEditorOrQuestAuthorOrQuestManager(
            user,
            quest,
            organization
          ) &&
            quest.reviewing_compiled_quest &&
            quest.reviewing_compiled_quest.state === 'rejected' && (
              <div
                className="quest-action button edit-quest"
                onClick={this.onEditQuestClickBound}
              >
                {editQuest}
              </div>
            )}
          {isQuestCopyEditorOrQuestAuthorOrQuestManager(
            user,
            quest,
            organization
          ) &&
            quest.reviewing_compiled_quest &&
            quest.reviewing_compiled_quest.state === 'published' && (
              <div
                className="quest-action button btn-secondary-dark"
                onClick={this.onEditPublishedQuestClickBound}
              >
                {editQuest}
              </div>
            )}
          {isQuestCopyEditorOrQuestAuthorOrQuestManager(
            user,
            quest,
            organization
          ) &&
            this.qdCanStopReview() && (
              <div
                className="sequestered-action-container"
                onClick={this.onStopReviewClickBound}
              >
                <div className="x-action"></div>
                <div className="sequestered-action-text">
                  <FormattedMessage
                    id={'Quest.ReviewBanner.StopReview'}
                    defaultMessage={'Stop Review'}
                  />
                </div>
              </div>
            )}
          {isActiveWithThisReviewer(activeReview, user) && (
            <div
              className="sequestered-action-container"
              onClick={this.onCancelReviewClickBound}
            >
              <div className="x-action"></div>
              <div className="sequestered-action-text">{cancelReview}</div>
            </div>
          )}
        </div>
        <ModalComponent
          ref="stopReviewModal"
          quest={quest}
          klass="review-modal modal"
          modalId="stopReviewModal"
          headingKlass="modal-heading alert"
          logoKlass="logo alert"
          headingText={modalMessages.header.reviewInProgress}
          bodyText={[
            modalMessages.body.ifYouStop1,
            <strong>&nbsp;{modalMessages.body.ifYouStop2}&nbsp;</strong>,
            modalMessages.body.ifYouStop3
          ]}
          primaryButtonText={modalMessages.button.ok}
          secondaryButtonText={modalMessages.button.cancel}
          primaryButtonAction={this.onActualStopReviewClickBound}
          secondaryButtonAction={this.hideModalBound}
        />
        <ModalComponent
          ref="cancelReviewModal"
          quest={quest}
          klass="review-modal modal"
          modalId="cancelReviewModal"
          headingKlass="modal-heading alert"
          logoKlass="logo alert"
          headingText={modalMessages.header.cancelReview}
          bodyText={modalMessages.body.ifYouCancel}
          primaryButtonText={modalMessages.button.yes}
          secondaryButtonText={modalMessages.button.no}
          primaryButtonAction={this.onActualCancelClickBound}
          secondaryButtonAction={this.hideModalBound}
        />
        <ModalComponent
          ref="editPublishedQuestModal"
          quest={quest}
          klass="review-modal modal"
          modalId="editPublishedQuestModal"
          headingKlass="modal-heading no-cap alert"
          logoKlass="logo alert"
          headingText={modalMessages.header.thisQuestIsPublished}
          bodyText={[
            modalMessages.body.toEditThisQuest,
            <span> </span>,
            <a href="mailto:support@opportunityeducation.org?" target="_top">
              support@opportunityeducation.org
            </a>,
            '.)'
          ]}
          primaryButtonText={modalMessages.button.ok}
          secondaryButtonText={modalMessages.button.cancel}
          primaryButtonAction={this.onActualEditPublishedQuestClickBound}
          secondaryButtonAction={this.hideModalBound}
        />
      </div>
    )
  }

  onEditPublishedQuestClick() {
    this.editPublishedQuestModal.show()
  }

  onActualEditPublishedQuestClick() {
    const { dispatch, quest } = this.props
    dispatch(revertQuestToDraft(quest.id, true))
    this.editPublishedQuestModal.hide()
  }

  onEditQuestClick() {
    const { dispatch, quest } = this.props
    dispatch(revertQuestToDraft(quest.id))
  }

  showReviewStatusIndicators() {
    const { user, quest, approvals, organization, activities } = this.props

    const reviewState = getReviewStatus(quest)
    let retVal = false
    if (
      (isInternalReviewer(user) ||
        isQuestCopyEditorOrQuestAuthorOrQuestManager(
          user,
          quest,
          organization
        )) &&
      reviewState === 'draft' &&
      approvals.length > 0 &&
      allRequiredFieldsComplete(quest, activities)
    ) {
      retVal = true
    } else if (isOeReviewer(user) && questIsInQualityReview(quest)) {
      retVal = true
    } else if (
      isQuestCopyEditorOrQuestAuthorOrQuestManager(user, quest, organization) &&
      questIsInRejectedState(quest)
    ) {
      retVal = true
    }

    return retVal
  }

  showBlackBanner() {
    const { user, quest, organization, approvals, activities } = this.props
    const currentReviewState = getReviewStatus(quest)
    let retVal = false
    if (
      isQuestCopyEditorOrQuestAuthorOrQuestManager(user, quest, organization)
    ) {
      retVal = true
    } else if (
      isInternalReviewer(user) &&
      currentReviewState === 'draft' &&
      approvals.length > 0 &&
      allRequiredFieldsComplete(quest, activities)
    ) {
      retVal = true
    } else if (isOeReviewer(user) && questIsInQualityReview(quest)) {
      retVal = true
    } else if (currentReviewState === 'published') {
      retVal = true
    }

    return retVal
  }

  qdCanStopReview() {
    return questIsInQualityReview(this.props.quest)
  }

  onStopReviewClick() {
    this.stopReviewModal.show()
  }

  onActualStopReviewClick() {
    this.props.dispatch(
      stopReview(
        this.props.quest.id,
        this.props.quest.reviewing_compiled_quest.id
      )
    )
    this.stopReviewModal.hide()
  }

  onCancelReviewClick() {
    this.cancelReviewModal.show()
  }

  onActualCancelClick() {
    const { quest, activeReview } = this.props
    this.props.dispatch(
      deleteCompiledQuestReview(
        quest.id,
        quest.reviewing_compiled_quest.id,
        activeReview.id
      )
    )
    this.cancelReviewModal.hide()
  }

  onActualSubmitForReviewClick() {
    this.props.dispatch(createCompiledQuest(this.props.quest.id))
    this.submitForReviewModal.hide()
  }

  hideModal() {
    this.stopReviewModal.hide()
    this.cancelReviewModal.hide()
    this.editPublishedQuestModal.hide()
  }
}

ReviewBanner.propTypes = {
  quest: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
  activeReview: PropTypes.object,
  previousReviews: PropTypes.array.isRequired,
  currentReviews: PropTypes.array.isRequired,
  organization: PropTypes.object.isRequired,
  approvals: PropTypes.array,
  activities: PropTypes.array.isRequired
}

ReviewBanner.contextTypes = {
  intl: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  user: state.user.user,
  activeReview: state.quest.activeReview,
  previousReviews: state.quest.previousReviews,
  currentReviews: state.quest.currentReviews,
  organization: state.organization,
  approvals: state.quest.approvals,
  activities: state.quest.activities
})

export default connect(mapStateToProps)(ReviewBanner)
export { ReviewBanner as ReviewBannerDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/ReviewBanner.js